import { render, staticRenderFns } from "./PageInner.vue?vue&type=template&id=402e42f4&scoped=true&"
import script from "./PageInner.vue?vue&type=script&lang=js&"
export * from "./PageInner.vue?vue&type=script&lang=js&"
import style0 from "./PageInner.vue?vue&type=style&index=0&id=402e42f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e42f4",
  null
  
)

export default component.exports